export const Loader = () => {
    return (
        <div className="flex justify-center items-center">
            <div className="animate-spin rounded-full w-8 h-8 border-4 border-gray-300 border-b-4 border-b-gray-800"></div>
        </div>
    )
}
